<template lang="pug">
.header-dropdown(:class="dropdownClasses")
  HeaderButton(
    :subtitle-top="subtitleTop"
    @click.stop="toggle()"
    :class="dropdownActivatorClasses"
  )
    template(
      #prepend
      v-if="hasPrepend"
    )
      slot(name="prepend")
    template(
      #subtitle
      v-if="hasSubtitle"
    )
      slot(name="subtitle") {{ subtitle }}
    template(#append)
      UiIcon(name="ChevroneBottom")
    | {{ label }}
  UiOptionsMenu.header-dropdown__content(
    @click.stop
    v-if="state"
  )
    slot(name="dropdown")
</template>

<script>
import HeaderButton from "./HeaderButton.vue";

export default {
  components: {
    HeaderButton,
  },

  props: {
    label: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    subtitleTop: {
      type: Boolean,
      default: false,
    },
    alignment: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      state: false,
    };
  },

  computed: {
    hasSubtitle() {
      return !!this.$slots.subtitle || this.subtitle;
    },

    hasPrepend() {
      return !!this.$slots.prepend;
    },

    dropdownClasses() {
      return {
        [`header-dropdown--${this.alignment}`]: !!this.alignment,
      };
    },

    dropdownActivatorClasses() {
      return {
        active: this.state,
      };
    },
  },

  mounted() {
    document.addEventListener("click", this.hide);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.hide);
  },

  methods: {
    show() {
      this.state = true;
    },

    hide() {
      this.state = false;
    },

    toggle() {
      this.state = !this.state;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/stylesheet/_variables.scss";

.header-dropdown {
  height: 100%;
  position: relative;

  &__content {
    min-width: 100px;
    position: absolute;
    top: calc(100% + 6px);
    left: -10px;
    padding: 0 !important;
    z-index: 5000;
  }

  &--right &__content {
    left: auto;
    right: -10px;
  }
}
</style>
